import { useCallback } from 'react';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex, StyledMaxWidth } from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

import { PatientDataAccessVerificationCodeField } from './PatientDataAccessVerificationCodeField';
import { PatientDataAccessVerificationCodeFormBean } from './PatientDataAccessVerificationCodeForm.types';
import { PatientDataAccessVerificationCodeVerifyButton } from './PatientDataAccessVerificationCodeVerifyButton';
import { PatientDidntReceiveInformation } from './PatientDidntReceiveInformation';

type PatientDataAccessVerificationCodeFormProps = {
   readonly onGoBackToAuthorizerChoice: VoidFunction;
   readonly onVerificationSuccess: VoidFunction;
   readonly onP1CommunicationFault: (faultDescription?: string) => void;
   readonly applicationId: string;
   readonly visitId: number;
};

export const PatientDataAccessVerificationCodeForm = (
   props: PatientDataAccessVerificationCodeFormProps
): JSX.Element => {
   const { register, setError, handleSubmit } = useFormController<PatientDataAccessVerificationCodeFormBean>({
      code: null,
   });

   const setIncorrectCodeError = useCallback(() => {
      setError('code', { message: prescriptionsHistoryDownloadTranslationKeys.incorrectCode });
   }, [setError]);
   return (
      <StyledFlex as={'form'} noValidate direction={'column'} gap={'8px'}>
         <StyledMaxWidth maxWidth={230}>
            <StyledFlex gap={'8px'} alignItems={'stretch'}>
               <PatientDataAccessVerificationCodeField register={register} />
               <PatientDataAccessVerificationCodeVerifyButton
                  handleSubmit={handleSubmit}
                  onIncorrectCodeFault={setIncorrectCodeError}
                  onP1CommunicationFault={props.onP1CommunicationFault}
                  onSuccess={props.onVerificationSuccess}
                  applicationId={props.applicationId}
                  visitId={props.visitId}
               />
            </StyledFlex>
         </StyledMaxWidth>
         <PatientDidntReceiveInformation onGoBackToAuthorizerChoiceClick={props.onGoBackToAuthorizerChoice} />
      </StyledFlex>
   );
};
